import assign from 'lodash/assign'

export default {
  name: 'UiForm',

  provide() {
    return {
      uiForm: this,
    }
  },

  // language=HTML
  template: `
    <form class="ui-form">
      <slot></slot>
    </form>
  `,

  props: {
    labelPosition: {
      type: String,
      default: 'top',
    },

    labelWidth: {
      type: String,
      default: '160px',
    },

    // Deprecated
    labelColumns: {
      type: Number,
      default: 4,
    },

    // Deprecated
    inputColumns: {
      type: Number,
      default: 8,
    },

    model: Object,
    rules: Object,
  },

  data() {
    return {
      fields: [],
    }
  },

  methods: {
    focusOnFirstError() {
      this.$nextTick(() => {
        const containerEl = this.$el.querySelector('.ui-form-item.is-error')
        if (!containerEl) {
          return
        }

        containerEl.scrollIntoView(true)
        window.scrollBy(0, -200)

        const scrolledY = window.scrollY
        if (scrolledY) {
          window.scroll(0, scrolledY - 40)
        }

        const inputEl = containerEl.querySelector(
          ['.ui-input__inner', '.ui-textarea__inner', '.ui-select__inner', '.form-check-input'].join(', '),
        )
        if (inputEl) {
          inputEl.focus()
        }
      })
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!this.model) {
          console.warn('[Form] model prop is required for validation')
          resolve(true)
          return
        }

        let valid = true
        let count = 0

        if (this.fields.length === 0) {
          resolve(true)
        }

        let invalidFields = {}
        this.fields.forEach((field) => {
          field.validate((message) => {
            if (message) {
              valid = false
            }

            invalidFields = assign({}, invalidFields, field)

            if (++count === this.fields.length) {
              if (valid) {
                resolve(valid)
              } else {
                reject(valid, invalidFields)
              }
            }
          })
        })
      })
    },
  },

  created() {
    this.$on('ui.form.addField', (field) => {
      if (field) {
        this.fields.push(field)
      }
    })

    this.$on('ui.form.removeField', (field) => {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    })
  },
}
